export default __webpack_public_path__ + "9262ad2270614b791628e98acc7b8a1f.png";